/**
 * Retrieves an item from local storage and parses it as JSON.
 *
 * @param {string} key - The key of the item to retrieve from local storage.
 * @returns {*} - The parsed JSON value associated with the key, or null if not found or an error occurs.
 */
export function getLocalItem(key) {
  try {
    if (typeof localStorage !== 'undefined') {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    }
    return null;
  } catch (e) {
    // Handle any JSON parsing errors by removing the item from local storage.
    localStorage.removeItem(key);
    return null;
  }
}

/**
 * Sets an item in local storage after converting it to a JSON string.
 *
 * @param {string} key - The key under which to store the item in local storage.
 * @param {*} data - The data to store in local storage. Will be converted to JSON before storage.
 */
export function setLocalItem(key, data) {
  if (typeof localStorage !== 'undefined') {
    try {
      const jsonData = JSON.stringify(data);
      localStorage.setItem(key, jsonData);
    } catch (e) {
      // Handle any JSON serialization errors.
      console.error('Error serializing data to JSON:', e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/localstorage.js